import React from 'react';
import { CreditCard, AlertCircle, ExternalLink, ShieldCheck, Calendar } from 'lucide-react';
export function PaymentCard() {
  const daysUntilDeadline = 18;
  const isUrgent = daysUntilDeadline <= 30;
  return <div className="bg-white rounded-2xl p-7 sm:p-8 h-full flex flex-col" style={{
    boxShadow: '0 4px 24px rgba(0,0,0,0.07)'
  }} data-id="element-386">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6" data-id="element-387">
        <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{
        backgroundColor: '#fff7ed'
      }} data-id="element-388">
          <CreditCard className="w-5 h-5" style={{
          color: '#f97316'
        }} data-id="element-389" />
        </div>
        <div data-id="element-390">
          <h3 className="font-semibold text-slate-800 text-base" data-id="element-391">
            Наступний платіж
          </h3>
          <p className="text-xs text-slate-400" data-id="element-392">
            Обов'язковий членський внесок
          </p>
        </div>
      </div>

      {/* Amount */}
      <div className="mb-5" data-id="element-393">
        <div className="flex items-baseline gap-1" data-id="element-394">
          <span className="text-5xl font-bold text-slate-800" data-id="element-395">₴ 650</span>
        </div>
        <p className="text-sm text-slate-500 mt-1.5" data-id="element-396">
          Щорічний членський внесок
        </p>
        <div className="mt-3 p-3 rounded-lg bg-slate-50 border border-slate-100" data-id="element-397">
          <div className="flex items-center justify-between text-xs mb-1.5" data-id="element-398">
            <span className="text-slate-500" data-id="element-399">Внесок у федерацію</span>
            <span className="font-semibold text-slate-700" data-id="element-400">₴ 500</span>
          </div>
          <div className="flex items-center justify-between text-xs" data-id="element-401">
            <span className="text-slate-500" data-id="element-402">Внесок у місцевий осередок</span>
            <span className="font-semibold text-slate-700" data-id="element-403">₴ 150</span>
          </div>
        </div>
      </div>

      {/* Deadline warning */}
      {isUrgent && <div className="flex items-center gap-2.5 p-3.5 rounded-xl mb-5" style={{
      backgroundColor: '#fff7ed'
    }} data-id="element-404">
          <AlertCircle className="w-4 h-4 flex-shrink-0" style={{
        color: '#f97316'
      }} data-id="element-405" />
          <div data-id="element-406">
            <p className="text-sm font-semibold" style={{
          color: '#ea580c'
        }} data-id="element-407">
              Залишилось {daysUntilDeadline} днів
            </p>
            <p className="text-xs" style={{
          color: '#fb923c'
        }} data-id="element-408">
              Дедлайн: 31 січня 2025
            </p>
          </div>
        </div>}

      {/* Previous payment status */}
      <div className="mb-6 p-4 rounded-xl" style={{
      backgroundColor: '#f8fafc'
    }} data-id="element-409">
        <div className="flex items-center justify-between mb-2.5" data-id="element-410">
          <div className="flex items-center gap-1.5" data-id="element-411">
            <Calendar className="w-3.5 h-3.5 text-slate-400" data-id="element-412" />
            <span className="text-xs text-slate-500" data-id="element-413">Оплачено за 2025 рік</span>
          </div>
          <span className="text-xs font-semibold" style={{
          color: '#3b8fd4'
        }} data-id="element-414">
            ✓ Сплачено
          </span>
        </div>
        <div className="h-2 rounded-full overflow-hidden" style={{
        backgroundColor: '#e2eaf2'
      }} data-id="element-415">
          <div className="h-full rounded-full" style={{
          width: '100%',
          backgroundColor: '#3b8fd4'
        }} data-id="element-416" />
        </div>
      </div>

      <div className="flex-1" data-id="element-417" />

      {/* LiqPay Button */}
      <button className="w-full flex items-center justify-center gap-2.5 py-3.5 px-4 rounded-xl text-white font-semibold text-sm transition-all hover:opacity-90 active:scale-[0.98]" style={{
      background: 'linear-gradient(135deg, #3b8fd4, #1d6fa8)',
      boxShadow: '0 4px 14px rgba(59,143,212,0.35)'
    }} data-id="element-418">
        <CreditCard className="w-4 h-4" data-id="element-419" />
        Сплатити через LiqPay
        <ExternalLink className="w-3.5 h-3.5 opacity-70" data-id="element-420" />
      </button>

      <div className="flex items-center justify-center gap-1.5 mt-3" data-id="element-421">
        <ShieldCheck className="w-3.5 h-3.5 text-slate-400" data-id="element-422" />
        <p className="text-xs text-slate-400" data-id="element-423">Безпечна оплата через LiqPay</p>
      </div>
    </div>;
}